<template>
<span class="data-point-configuration">
  <div class="leftTree">
    <el-tree :data="nodeList" default-expand-all :expand-on-click-node="false" highlight-current node-key="id" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
  </div>
  <div class="rightTable">
    <el-table ref="singleTable" :data="tableData" stripe height="57.5vh" style="width: 100%;">
      <el-table-column label="" width="50">
        <template slot-scope="scope">
          <el-radio :label="scope.$index" v-model="radio" @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="field" label="点位名称" min-width="270"></el-table-column>
      <el-table-column prop="fieldDesc" label="点位描述" min-width="190"></el-table-column>
      <el-table-column prop="authorization" label="权限">
        <template slot-scope="scope">
          {{scope.row.authorization == 0 ? "读" : scope.row.authorization == 1 ? "写" : "读写"}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</span>
</template>

<script>
import PROJECTAPI from '@/api/project';
export default {
  props: {
    projectId: {
      type: [String, Number]
    },
    isDialog: {
      type: Boolean
    }
  },
  data() {
    return {
      nodeList: [],
      defaultProps: {
        children: 'childrenList',
        label: 'field'
      },
      tableData: [],
      radio: null
    };
  },
  watch: {
    isDialog(val) {
      if (val) {
        this.radio = null;
        this.searchFieldTreeByProject();
      }
    }
  },
  created() {
  },
  mounted() {
    this.searchFieldTreeByProject();
  },
  methods: {
    searchFieldTreeByProject() {
      let params = {
        projectId: this.projectId
      };
      PROJECTAPI.searchFieldTreeByProject(params).then(res => {
        this.nodeList = res.data.data.fieldTreeVoList;
      });
    },
    handleNodeClick(data) {
      let params = {
        emsId: data.emsId,
        field: data.currentFullField,
        projectId: this.projectId,
        authorizations: "0, 1, 2"
      };
      PROJECTAPI.searchFieldByTree(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
      });
    },
    getCurrentRow(row) {
      this.$emit("currRowData", row);
    },
  }
};
</script>

<style lang="scss">
.data-point-configuration {
  .leftTree {
    float: left;
    width: 22%;
    height: 58vh;
    border: 1px solid #ccc;
    overflow: auto;
  }

  .rightTable {
    float: left;
    width: calc(78% - 10px);
    height: 58vh;
    border: 1px solid #ccc;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/data-point-configuration.vue